"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppEventRequestDetails {
    constructor(userId, sessionId, eventName, origin, parameters = {}, channel = 'Web', language = 'en-US', userData, accessKey) {
        this.userId = userId;
        this.sessionId = sessionId;
        this.eventName = eventName;
        this.origin = origin;
        this.parameters = parameters;
        this.channel = channel;
        this.language = language;
        this.userData = userData;
        this.accessKey = accessKey;
    }
}
exports.default = AppEventRequestDetails;
//# sourceMappingURL=AppEventRequestDetails.js.map